export default __webpack_public_path__ + "static/media/dart-field.8b4b7df3.png";